import styled from '@emotion/styled';

export const LIHeaderChild = styled.li`
  dt,
  dd {
    font-size: 12px;
  }
  dt {
    color: #9699a3 !important;
  }
  dd {
    color: #515359 !important;
  }
`;
